/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 商城获取用户信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.MemberShoppingInfoRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/member/shopping-mall/info`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
